'use client';
import { Box } from '@mui/material';
import { useTranslation } from '@/hook';
import {
    ArrowRightDark,
    FaultyCheckMark,
    FixedMark,
    ImperfectionCheckMark,
} from '../../../public/Images';
import Image from 'next/image';
import Typography from '@/components/shared/typography/typography.component';
import { IImperfectionReportItemTypes, ImperfectionStatusEnum } from '@/types';

const ImperfectionItem = ({
    title_en,
    title_ar,
    faultyItemsNumber,
    fixedItemsNumber,
    icon,
    section_type,
    textOnlyValueAr,
    textOnlyValueEn,
    ImperfectionStatus,
}: {
    title_en: string;
    title_ar: string;
    faultyItemsNumber: number;
    fixedItemsNumber: number;
    section_type: IImperfectionReportItemTypes;
    icon: any;
    textOnlyValueAr: string;
    textOnlyValueEn: string;
    ImperfectionStatus: ImperfectionStatusEnum;
}) => {
    const { IS_RTL } = useTranslation();
    const imperfectionItemContainer = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '8px 4px 8px 0px',
        width: '100%',
    };
    const imperfectionItemTitleSection = {
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: 1,
    };
    const imperfectionItemIcon = {
        width: '32px',
        height: '32px',
        marginInlineEnd: '12px',
    };
    const imperfectionItemText = {
        color: '#344054',
        opacity: 1,
    };

    const faultyItemNumber = {
        color: '#DC6803',
        opacity: 1,
        margin: '3px',
    };
    // const fixedItemNumber = {
    //     color: '#009B5D',
    //     opacity: 1,
    //     margin: '3px',
    // };
    const arrowStyle = {
        transform: IS_RTL ? 'scaleX(-1)' : 'scaleX(1)',
    };
    const iconsContainer = {
        gap: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    };
    const hasFaults = faultyItemsNumber > 0;
    const hasFixes = fixedItemsNumber > 0;

    return (
        <Box
            sx={{
                ...imperfectionItemContainer,
                cursor:
                    section_type === IImperfectionReportItemTypes.GENERIC
                        ? 'pointer'
                        : '',
            }}
        >
            <Box sx={imperfectionItemTitleSection}>
                <Box sx={imperfectionItemIcon}>
                    {hasFaults ? (
                        <Image
                            width={36}
                            height={36}
                            style={{ objectFit: 'contain' }}
                            src={icon?.faulty}
                            alt={title_en}
                        />
                    ) : (
                        <Image
                            width={36}
                            height={36}
                            style={{ objectFit: 'contain' }}
                            src={icon?.good}
                            alt={title_en}
                        />
                    )}
                </Box>

                <Typography
                    style={{
                        ...imperfectionItemText,
                        color:
                            ImperfectionStatus === ImperfectionStatusEnum.Faulty
                                ? faultyItemNumber.color
                                : 'inherit',
                    }}
                    variant={'body2Medium'}
                >
                    {section_type === IImperfectionReportItemTypes.TEXT_ONLY
                        ? IS_RTL
                            ? textOnlyValueAr
                            : textOnlyValueEn
                        : IS_RTL
                        ? title_ar
                        : title_en}
                </Typography>
            </Box>
            {section_type === IImperfectionReportItemTypes.GENERIC ? (
                <Box sx={iconsContainer}>
                    {hasFixes && (
                        <Box sx={imperfectionItemTitleSection}>
                            {/* <Typography
                                style={fixedItemNumber}
                                variant={'body2'}
                            >
                                {fixedItemsNumber}
                            </Typography> */}
                            <Image
                                src={FixedMark}
                                height={24}
                                alt="fixedMark"
                            />
                        </Box>
                    )}
                    {hasFaults && (
                        <Box sx={imperfectionItemTitleSection}>
                            {/* <Typography
                                style={faultyItemNumber}
                                variant={'body2'}
                            >
                                {faultyItemsNumber}
                            </Typography> */}
                            <Image
                                src={FaultyCheckMark}
                                height={24}
                                alt="FaultyCheckMark"
                            />
                        </Box>
                    )}
                    {!(hasFaults || hasFixes) && (
                        <Box sx={imperfectionItemTitleSection}>
                            <Image
                                src={ImperfectionCheckMark}
                                height={24}
                                alt="ImperfectionCheckMark"
                            />
                        </Box>
                    )}
                    <Image
                        src={ArrowRightDark}
                        alt="ArrowRightDark"
                        style={arrowStyle}
                    />
                </Box>
            ) : null}
        </Box>
    );
};
export default ImperfectionItem;
